import { Card, Col, DatePicker, Form, Input, Row, Typography } from "antd";
import dayjs from 'dayjs';
import React from "react";
const { Title } = Typography;
const dateFormat = 'MM/DD/YYYY';

const PatientInformation = ({ getChildData }) => {
  const callparent = (e, name) => {
    getChildData(e, name);
  };
  const disableFutureDates = (current) => {
    // Can not select days after today
    return current && current > dayjs().endOf('day');
  };
  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          Patient Information
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6">
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="ffirstname"
            label="Patient's First Name"
            onChange={(e) => callparent(e.target.value, "PatientFirstName")}
            required
            rules={[{ required: true, max: 50, message: "Please enter patient's first name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Patient's Last Name"
            name="lastname"
            onChange={(e) => callparent(e.target.value, "PatientLastName")}
            required
            rules={[{ required: true, max: 50, message: "Please enter patient's last name." }]}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            name="dob"
            label="Date of Birth"
            required
            rules={[
              {
                required: true,
                message: "Please enter date of birth.",
              },
            ]}
          >
            <DatePicker
              disabledDate={disableFutureDates}
              format={dateFormat}
              style={{ minWidth: "100%" }}
              onChange={(e) => callparent(e, "PatientDOB")}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            className="font-medium"
            label="Email"
            name="Pemail"
            onChange={(e) => callparent(e.target.value, "PatientEmail")}
            rules={[
              { max: 100, message: "Please enter email." },
              { type: "email", message: "Please enter valid email." },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};
export default PatientInformation;
